import {
  buildAppPath,
  parseAppPath,
  pathWithLocale,
  type AppLocale,
  type AppRouteState,
} from '@redevicer/shared'

const PRESERVED_QUERY_KEYS = [
  'reset_token',
  'guest_listing',
  'payment',
  'stripe_connect',
  'session_id',
  'exchange_pass',
] as const

export function readAppRouteFromLocation(pathname = window.location.pathname, search = window.location.search): AppRouteState {
  return parseAppPath(pathname, search)
}

export function buildAppUrl(state: AppRouteState, locale: AppLocale, currentSearch = ''): string {
  const path = buildAppPath(state)
  const preserved = new URLSearchParams()
  const params = new URLSearchParams(currentSearch.startsWith('?') ? currentSearch.slice(1) : currentSearch)
  for (const key of PRESERVED_QUERY_KEYS) {
    const value = params.get(key)
    if (value) preserved.set(key, value)
  }
  const preservedQs = preserved.toString()
  const pathSearch = path.includes('?') ? path.slice(path.indexOf('?')) : ''
  const pathOnly = pathSearch ? path.slice(0, path.indexOf('?')) : path

  let search = pathSearch
  if (preservedQs) {
    search = search ? `${search}&${preservedQs}` : `?${preservedQs}`
  }

  return pathWithLocale(locale, pathOnly, search)
}

export function isListingPath(pathname: string): boolean {
  return readAppRouteFromLocation(pathname).listingId != null
}

export function isOfferPath(pathname: string): boolean {
  return readAppRouteFromLocation(pathname).offerId != null
}

export function isLegalPath(pathname: string): boolean {
  return readAppRouteFromLocation(pathname).legalDoc != null
}
